export const avisosFields = [
  { label: "Razón Social Empresa", name: "razonSocial" },
  { label: "RFC de la Empresa", name: "rfcEmpresa" },
  { label: "Numero de Registro Patronal", name: "nrp" },
  { label: "Domicilio de la Empresa", name: "domEmpresa" },
  { label: "Nombre del Empleado", name: "nombreTrab" },
  { label: "CURP del Empleado", name: "curpTrabajador" },
  { label: "RFC del Empleado", name: "rfcTrabajador" },
  { label: "Numero de Seguridad Social del Empleado", name: "nss" },
  { label: "NSS Completo del Empleado", name: "nssUnificado" },
  { label: "Fecha de Ultimo Aviso", name: "fechaUltimoAviso" },
  { label: "Fecha de Creación de Aviso", name: "fechCreaAviso" },
  {
    label: "Fecha de Otorgamiento de Crédito",
    name: "fechOtorgamiento",
  },
  { label: "Folio de Aviso", name: "folioAviso" },
  { label: "Numero de Crédito", name: "numCredito" },
  {
    label: "Tipo de Aviso",
    name: "tipoAviso",
  },
  {
    label: "Tipo de Descuento",
    name: "tipoDescuento",
  },
  {
    label: "Tipo de Crédito",
    name: "tipoCredito",
  },
  { label: "Estatus del Crédito", name: "estatusCredito" },
  { label: "Monto de Descuento", name: "monDescuento" },
  { label: "Factor de Descuento", name: "facDescuento" },
];

// Type dicts
export const avisoTypes = {
  "01": "Retención",
  "02": "Retención",
  "03": "Modificación",
  "04": "Retención",
  "05": "Retención",
  "06": "Retención",
  "07": "Modificación",
  "08": "Retención",
  10: "Suspensión",
  11: "Suspensión",
  12: "Suspensión",
  13: "Suspensión",
  14: "Suspensión",
  15: "Suspensión",
};

export const descTypes = {
  1: "Porcentaje",
  2: "Cuota fija en pesos",
  3: "Cuota fija en veces salario Minimo",
};

export const creditTypes = {
  "001": "Credito Tradicional",
  "002": "Credito Apoyo INFONAVIT",
  "003": "Credito Cofinanciado",
  "004": "Infonavit Total",
  "005": "Credito Cofinanciado 08",
  10: "Cofinavit AG",
  11: "Infonavit Total AG",
  12: "Credito Mejora tu Casa",
  14: "Credito Linea IV",
  15: "2do Credito INFONAVIT",
  16: "2do Credito INFONAVIT AG",
  17: "Credito Estados Municipios",
  18: "Credito Rentas",
  19: "Credito Mejoravit",
  20: "Manos a la Obra",
  21: "Credito Un Cuarto Mas",
  23: "Credito Mejoravit Plus",
  25: "Credito 25 Movilidad",
  26: "Credito 26 Mejora y Repara",
  27: "Credito Ind INFONAVIT-FOVISSSTE",
  28: "ConstruYo (autoproduccion)",
  29: "Unamos (solidarios) (Familiares)",
  30: "Unamos (solidarios) (Corresidencial)",
  31: "Cuenta Infonavit + Credito Bancario",
  32: "Mejora Directa Infonavit Mejora si",
  34: "Pago de pasivos (Tradicional pero c/uso de garantia) (con relacion laboral)",
};

// NSSUnificado default value
export const updateNSSAndNSSUnificadoValue = (aviso) => {
  const defaultNSSUnificado = aviso?.nssUnificado === "00000000000" || aviso?.nssUnificado === null;
  const nss = aviso?.nss;

  if (nss?.length === 11 && defaultNSSUnificado) {
    aviso.nssUnificado = nss;
    aviso.nss = nss.substring(0, 10);
  }

  return aviso;
}